import { mergeScopeIntoSearch, scopeFromSearch } from '../../../lib/scope-search.js';
import type { OpenedRun } from './RunsTab.js';

export function withoutTab(search: Record<string, unknown>): Record<string, unknown> {
  const { tab: _tab, ...rest } = search;
  return rest;
}

// A run reopens on the accounts and dates it ran with, not the list's scope.
export function runSearch(
  previous: Record<string, unknown>,
  run: OpenedRun,
): Record<string, unknown> {
  const scope = scopeFromSearch(previous);
  return {
    ...mergeScopeIntoSearch(withoutTab(previous), {
      ...scope,
      brand: [],
      platform: [],
      account: run.accountIds.map(String),
      range: { ...scope.range, mode: 'custom', from: run.startDate, to: run.endDate },
    }),
    run: run.runId,
  };
}
